module.exports = __webpack_public_path__ + "img/sacDesktop-es-ES.30cb909c.png";